/**
 * Project : workspace
 * File    : AlertDialogue.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package component.alert

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.material3.CardColors
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CardElevation
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Shape
import androidx.compose.ui.window.Dialog
import com.parmartechnologies.commerce.feature.alert.viewModel.AlertViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch
import theme.ThemeColor

@Composable
/**
 * Executes the alert dialogue operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
fun AlertDialogue(
    viewModel : AlertViewModel = AlertViewModel(),
    modifier: Modifier = Modifier.wrapContentSize(),
    shape: Shape = CardDefaults.shape,
    colors: CardColors = CardDefaults.cardColors(),
    elevation: CardElevation = CardDefaults.cardElevation(),
    border: BorderStroke? = null,
    content: @Composable ColumnScope.() -> Unit) {
    val isOpenDialog = viewModel.isAlertVisible.collectAsState()
    if(isOpenDialog.value){
        Dialog(
            onDismissRequest = {
                CoroutineScope(Job() + Dispatchers.Default).launch {
                    viewModel.repository.isAlertVisible.emit(false)
                }
            },
        ) {
            Surface(
                modifier = modifier,
                shape = shape,
                color = ThemeColor.shared().cardBackground,
                contentColor = ThemeColor.shared().cardBackground,
//        shadowElevation = ,
                border = border,
            ) {
                Column(content = content, modifier = Modifier.wrapContentSize())
            }
        }
    }


}